import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Button from 'components/Button/Button';
import Map from 'components/Map/Map';
import UserStore from 'stores/User';
import ZonesStore from 'stores/Zones';
import styles from './Main.module.scss';

// const LAT = 29.218103;
// const LNG = -81.031723;

const Main = observer(() => {

  const navigate = useNavigate();

  useEffect(() => {
    UserStore.getLocation();
  }, []);

  useEffect(() => {
    if (UserStore.latitude && UserStore.longitude) {
      // ZonesStore.fetch(LAT, LNG)
      ZonesStore.fetch(UserStore.latitude, UserStore.longitude)
    }
  }, [ UserStore.lastLocationUpdate ]);

  function start() {
    navigate('/ride/create');
  }

  function addFunds() {
    navigate('/funds');
  }

  function getCenter() {
    if (!UserStore.latitude || !UserStore.longitude) {
      return null;
    }
    
    // return {
    //   lat: LAT,
    //   lng: LNG
    // }
    
    return {
      lat: UserStore.latitude,
      lng: UserStore.longitude
    }
  }
  

  return (
    <div className={styles.container}>
      {UserStore.locationPermission !== 'denied' && 
        <Map 
          center={getCenter()}
          zoom={14}
        />
      }
      <Button
        grey
        className={styles.fundsButton}
        onClick={addFunds}
      >
        Add Funds
      </Button>
      <Button 
        light 
        className={styles.button}
        onClick={start}
      >
        Ride
      </Button>
    </div>
  );
});

export default Main;
